<template>
  <div>
    <v-progress-circular v-if="loading" indeterminate color="primary" />
    <div v-else-if="bodyHtml" class="legal-content" v-html="bodyHtml" />
    <div v-else class="grey--text text--darken-1">
      No terms &amp; conditions are available for this tenant.
    </div>
  </div>
</template>

<script>
import { fetchTermsConditions } from '@/services/terms-conditions'

export default {
  data: () => ({
    loading: false,
    bodyHtml: '',
    fetchFailed: false
  }),

  async created() {
    this.loading = true
    try {
      const response = await fetchTermsConditions()
      this.bodyHtml = response?.bodyHtml || ''
    } catch (error) {
      this.fetchFailed = true
    } finally {
      this.loading = false
    }
  }
}
</script>

<style scoped>
.legal-content :deep(h1),
.legal-content :deep(h2),
.legal-content :deep(h3),
.legal-content :deep(h4),
.legal-content :deep(h5),
.legal-content :deep(h6) {
  text-decoration: none !important;
}
</style>
